import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../public/img/lang-icon.svg'
import _imports_1 from '../public/img/user.svg'
import _imports_2 from '../public/img/arr1.svg'
import _imports_3 from '../public/img/logo1.svg'
import _imports_4 from '../public/img/w1.svg'
import _imports_5 from '../public/img/figure.svg'
import _imports_6 from '../public/img/arr4.svg'
import _imports_7 from '../public/img/w3.svg'
import _imports_8 from '../public/img/scroll.svg'
import _imports_9 from '../public/img/agent.svg'
import _imports_10 from '../public/img/boomerang.svg'
import _imports_11 from '../public/img/mp.svg'
import _imports_12 from '../public/img/brazino.svg'
import _imports_13 from '../public/img/bons.svg'
import _imports_14 from '../public/img/7stars.svg'
import _imports_15 from '../public/img/pinup.svg'
import _imports_16 from '../public/img/ava1.svg'
import _imports_17 from '../public/img/mail_ic.svg'
import _imports_18 from '../public/img/tg_ic.svg'
import _imports_19 from '../public/img/ava2.svg'
import _imports_20 from '../public/img/ava3.svg'
import _imports_21 from '../public/img/logo(7).svg'


const _hoisted_1 = { class: "tip-top" }
const _hoisted_2 = { class: "mobile-menu" }
const _hoisted_3 = { class: "mobile-menu__container" }
const _hoisted_4 = { class: "mobile-menu__top" }
const _hoisted_5 = { class: "lang" }
const _hoisted_6 = { class: "lang__cont" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "lang__icon"
}, null, -1)
const _hoisted_8 = { class: "lang__list" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mobile-menu__close" }, null, -1)
const _hoisted_10 = { class: "mobile-menu__components" }
const _hoisted_11 = { class: "mobile-menu__list" }
const _hoisted_12 = {
  href: "#about",
  class: "mobile-menu__item"
}
const _hoisted_13 = {
  href: "#advert",
  class: "mobile-menu__item"
}
const _hoisted_14 = {
  href: "#publish",
  class: "mobile-menu__item"
}
const _hoisted_15 = {
  href: "#review",
  class: "mobile-menu__item"
}
const _hoisted_16 = {
  href: "#contacts",
  class: "mobile-menu__item"
}
const _hoisted_17 = { class: "mobile-menu__btn" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_22 = { class: "head" }
const _hoisted_23 = { class: "head__container container" }
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "head__menu" }
const _hoisted_28 = {
  href: "#about",
  class: "head__link"
}
const _hoisted_29 = {
  href: "#advert",
  class: "head__link"
}
const _hoisted_30 = {
  href: "#publish",
  class: "head__link"
}
const _hoisted_31 = {
  href: "#contacts",
  class: "head__link"
}
const _hoisted_32 = { class: "head__right" }
const _hoisted_33 = { class: "head__btn" }
const _hoisted_34 = { class: "lang" }
const _hoisted_35 = { class: "lang__cont" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "lang__icon"
}, null, -1)
const _hoisted_37 = { class: "lang__list" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "head__mobile-btn" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_43 = { class: "main" }
const _hoisted_44 = { class: "container main__container" }
const _hoisted_45 = { class: "main__title" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"main__one\"><img src=\"" + _imports_4 + "\" alt=\"\"><div class=\"main__figure\"><img src=\"" + _imports_5 + "\" alt=\"\"></div></div><h1 id=\"hello\" class=\"\"><div class=\"parallax\">MARKETING</div></h1>", 2)
const _hoisted_48 = { class: "main__three" }
const _hoisted_49 = { class: "main__btn-container" }
const _hoisted_50 = ["href"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "main__stars" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  })
], -1)
const _hoisted_53 = { class: "scroll" }
const _hoisted_54 = {
  href: "#about",
  class: "scroll__item"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
}, null, -1)
const _hoisted_56 = {
  id: "about",
  class: "about"
}
const _hoisted_57 = { class: "container about__container" }
const _hoisted_58 = { class: "about__title star-title" }
const _hoisted_59 = { class: "about__info" }
const _hoisted_60 = { class: "about__info" }
const _hoisted_61 = { class: "about__info" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { class: "promotion" }
const _hoisted_64 = { class: "container promotion__container" }
const _hoisted_65 = {
  id: "advert",
  class: "promotion__article"
}
const _hoisted_66 = { class: "promotion__title" }
const _hoisted_67 = { class: "promotion__info" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: "",
  class: "promotion__img parallaxMan"
}, null, -1)
const _hoisted_69 = {
  id: "publish",
  class: "promotion__article"
}
const _hoisted_70 = { class: "promotion__title" }
const _hoisted_71 = { class: "promotion__info" }
const _hoisted_72 = {
  id: "review",
  class: "review"
}
const _hoisted_73 = { class: "container review__container" }
const _hoisted_74 = { class: "review__title star-title" }
const _hoisted_75 = { class: "review__slider slick-slider" }
const _hoisted_76 = { class: "review__item" }
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<div class=\"review__head\"><div class=\"review__logo\"><img src=\"" + _imports_10 + "\" alt=\"\"></div><div class=\"review__company\"><p class=\"review__company-name\">Boomerang Partners</p><p class=\"review__company-type\">Advertiser</p></div></div>", 1)
const _hoisted_78 = { class: "review__content" }
const _hoisted_79 = { class: "review__item" }
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div class=\"review__head\"><div class=\"review__logo\"><img src=\"" + _imports_11 + "\" alt=\"\"></div><div class=\"review__company\"><p class=\"review__company-name\">Moon Partners</p><p class=\"review__company-type\">Advertiser</p></div></div>", 1)
const _hoisted_81 = { class: "review__content" }
const _hoisted_82 = { class: "review__item" }
const _hoisted_83 = /*#__PURE__*/_createStaticVNode("<div class=\"review__head\"><div class=\"review__logo\"><img src=\"" + _imports_12 + "\" alt=\"\"></div><div class=\"review__company\"><p class=\"review__company-name\">BrazPartners</p><p class=\"review__company-type\">Advertiser</p></div></div>", 1)
const _hoisted_84 = { class: "review__content" }
const _hoisted_85 = { class: "review__item" }
const _hoisted_86 = /*#__PURE__*/_createStaticVNode("<div class=\"review__head\"><div class=\"review__logo\"><img src=\"" + _imports_13 + "\" alt=\"\"></div><div class=\"review__company\"><p class=\"review__company-name\">Bons Partners</p><p class=\"review__company-type\">Advertiser</p></div></div>", 1)
const _hoisted_87 = { class: "review__content" }
const _hoisted_88 = { class: "review__item" }
const _hoisted_89 = /*#__PURE__*/_createStaticVNode("<div class=\"review__head\"><div class=\"review__logo\"><img src=\"" + _imports_14 + "\" alt=\"\"></div><div class=\"review__company\"><p class=\"review__company-name\">7Stars Partners</p><p class=\"review__company-type\">Advertiser</p></div></div>", 1)
const _hoisted_90 = { class: "review__content" }
const _hoisted_91 = { class: "review__item" }
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"review__head\"><div class=\"review__logo\"><img src=\"" + _imports_15 + "\" alt=\"\"></div><div class=\"review__company\"><p class=\"review__company-name\">Pin-up </p><p class=\"review__company-type\">Advertiser</p></div></div>", 1)
const _hoisted_93 = { class: "review__content" }
const _hoisted_94 = {
  id: "contacts",
  class: "contact"
}
const _hoisted_95 = { class: "container contact__container" }
const _hoisted_96 = { class: "contact__title star-title" }
const _hoisted_97 = { class: "contact__list" }
const _hoisted_98 = { class: "contact__item h-adv" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "contact__avatar yellow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_16,
    alt: ""
  })
], -1)
const _hoisted_100 = { class: "contact__name" }
const _hoisted_101 = { class: "contact__position" }
const _hoisted_102 = /*#__PURE__*/_createStaticVNode("<div class=\"contact__separator\"></div><div class=\"contact__social\"><a href=\"mailto:prevkat@uqt.gr\" class=\"contact__link\"><img src=\"" + _imports_17 + "\" alt=\"\" class=\"contact__icon\"><span>prevkat@uqt.gr</span></a><a href=\"https://t.me/gmbtkat\" class=\"contact__link\"><img src=\"" + _imports_18 + "\" alt=\"\" class=\"contact__icon\"><span>@gmbtkat</span></a></div>", 2)
const _hoisted_104 = { class: "contact__item h-aff" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "contact__avatar blue" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_19,
    alt: ""
  })
], -1)
const _hoisted_106 = { class: "contact__name" }
const _hoisted_107 = { class: "contact__position" }
const _hoisted_108 = /*#__PURE__*/_createStaticVNode("<div class=\"contact__separator\"></div><div class=\"contact__social\"><a href=\"mailto:adver@gambeat.io\" class=\"contact__link\"><img src=\"" + _imports_17 + "\" alt=\"\" class=\"contact__icon\"><span>adver@gambeat.io</span></a><a href=\"https://t.me/gambeat_adver\" class=\"contact__link\"><img src=\"" + _imports_18 + "\" alt=\"\" class=\"contact__icon\"><span>@gambeat_adver</span></a></div>", 2)
const _hoisted_110 = { class: "contact__item h-pr" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "contact__avatar red" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_20,
    alt: ""
  })
], -1)
const _hoisted_112 = { class: "contact__name" }
const _hoisted_113 = { class: "contact__position" }
const _hoisted_114 = /*#__PURE__*/_createStaticVNode("<div class=\"contact__separator\"></div><div class=\"contact__social\"><a href=\"mailto:pr@gambeat.io\" class=\"contact__link\"><img src=\"" + _imports_17 + "\" alt=\"\" class=\"contact__icon\"><span>pr@gambeat.io</span></a><a href=\"https://t.me/dariia_kolesnyk\" class=\"contact__link\"><img src=\"" + _imports_18 + "\" alt=\"\" class=\"contact__icon\"><span>@dariia_kolesnyk</span></a></div>", 2)
const _hoisted_116 = { class: "foot" }
const _hoisted_117 = { class: "foot__container container" }
const _hoisted_118 = { class: "foot__part" }
const _hoisted_119 = ["href"]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_21,
  alt: "",
  class: "foot__logo"
}, null, -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = { class: "foot__privacy" }
const _hoisted_123 = {
  href: "#about",
  class: "mobile-menu__item mobile-menu__item__footer"
}
const _hoisted_124 = {
  href: "#contacts",
  class: "mobile-menu__item mobile-menu__item__footer"
}
const _hoisted_125 = { class: "mobile-menu__list" }
const _hoisted_126 = {
  href: "#advert",
  class: "mobile-menu__item mobile-menu__item__footer"
}
const _hoisted_127 = {
  href: "#publish",
  class: "mobile-menu__item mobile-menu__item__footer"
}
const _hoisted_128 = /*#__PURE__*/_createStaticVNode("<div class=\"foot__col\"><div class=\"foot__social\"><a href=\"https://www.instagram.com/gambeat.io?igsh=YnFmOWd0a2hodjc0\" target=\"_blank\" class=\"in\"><span>Instagram</span></a><a href=\"https://www.linkedin.com/company/gambeat/\" target=\"_blank\" class=\"link\"><span>LinkedIn</span></a><a href=\"https://t.me/gambeat_io\" target=\"_blank\" class=\"tg\"><span>Telegram</span></a></div></div><div class=\"foot__col\"></div><div class=\"foot__col\"></div>", 3)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "foot__copyright" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Gambeat - iGaming Marketing Agency. All Rights Reserved."),
  /*#__PURE__*/_createElementVNode("span", null, "© 2024")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.langLabel), 1),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLang('en'))),
                class: "lang__item"
              }, "English"),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang('ua'))),
                class: "lang__item"
              }, "Українська")
            ])
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('about_us')), 1),
            _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('advertisers')), 1),
            _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t('publishers')), 1),
            _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t('reviews')), 1),
            _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('contacts')), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("a", {
              href: `https://affiliate.gambeat.io/login${_ctx.getReferrerParamsStr()}`,
              class: "mobile-menu__login"
            }, [
              _hoisted_19,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('login')), 1)
            ], 8, _hoisted_18),
            _createElementVNode("a", {
              href: `https://gambeat.network/registration`,
              class: "mobile-menu__sign-up"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('sign_up')), 1),
              _hoisted_21
            ], 8, _hoisted_20)
          ])
        ])
      ])
    ]),
    _createElementVNode("header", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("a", {
          class: "head__logo",
          href: `https://gambeat.io/${_ctx.getReferrerParamsStr()}`
        }, _hoisted_26, 8, _hoisted_24),
        _createElementVNode("nav", _hoisted_27, [
          _createElementVNode("a", _hoisted_28, _toDisplayString(_ctx.$t('about_us')), 1),
          _createElementVNode("a", _hoisted_29, _toDisplayString(_ctx.$t('advertisers')), 1),
          _createElementVNode("a", _hoisted_30, _toDisplayString(_ctx.$t('publishers')), 1),
          _createElementVNode("a", _hoisted_31, _toDisplayString(_ctx.$t('contacts')), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", null, _toDisplayString(_ctx.langLabel), 1),
                _hoisted_36
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLang('en'))),
                  class: "lang__item"
                }, "English"),
                _createElementVNode("span", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeLang('ua'))),
                  class: "lang__item"
                }, "Українська")
              ])
            ]),
            _createElementVNode("a", {
              href: `https://affiliate.gambeat.io/login${_ctx.getReferrerParamsStr()}`,
              class: "head__login"
            }, [
              _hoisted_39,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('login')), 1)
            ], 8, _hoisted_38),
            _createElementVNode("a", {
              href: `https://gambeat.network/registration`,
              class: "head__sign-up"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('sign_up')), 1),
              _hoisted_41
            ], 8, _hoisted_40)
          ]),
          _hoisted_42
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("a", {
                href: `https://gambeat.network/registration`,
                class: "main__btn"
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('get_started')), 1),
                _hoisted_51
              ], 8, _hoisted_50)
            ]),
            _hoisted_52
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("a", _hoisted_54, [
        _hoisted_55,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('scroll_down')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("h3", _hoisted_58, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('about_us')), 1)
        ]),
        _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('about_info_1')), 1),
        _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t('about_info_2')), 1),
        _createElementVNode("p", _hoisted_61, [
          _createTextVNode(_toDisplayString(_ctx.$t('about_info_3')) + " ", 1),
          _hoisted_62,
          _createTextVNode(_toDisplayString(_ctx.$t('about_info_4')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("h4", _hoisted_66, _toDisplayString(_ctx.$t('advertisers')), 1),
          _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t('advertisers_info')), 1)
        ]),
        _hoisted_68,
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("h4", _hoisted_70, _toDisplayString(_ctx.$t('publishers')), 1),
          _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.$t('publishers_info_1')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_72, [
      _createElementVNode("div", _hoisted_73, [
        _createElementVNode("h3", _hoisted_74, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('voice_our_partners')), 1)
        ]),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.$t('boomerang_review')), 1)
          ]),
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('moon_partners_review')), 1)
          ]),
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.$t('brazino_review')), 1)
          ]),
          _createElementVNode("div", _hoisted_85, [
            _hoisted_86,
            _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.$t('bons_review')), 1)
          ]),
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t('seven_stars_review')), 1)
          ]),
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.$t('pinup_review')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_94, [
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("h3", _hoisted_96, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('contacts')), 1)
        ]),
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("div", _hoisted_98, [
            _hoisted_99,
            _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.$t('kate')), 1),
            _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.$t('head_of_affiliate')), 1),
            _hoisted_102
          ]),
          _createElementVNode("div", _hoisted_104, [
            _hoisted_105,
            _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.$t('david')), 1),
            _createElementVNode("p", _hoisted_107, _toDisplayString(_ctx.$t('cbdo')), 1),
            _hoisted_108
          ]),
          _createElementVNode("div", _hoisted_110, [
            _hoisted_111,
            _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.$t('dariia')), 1),
            _createElementVNode("p", _hoisted_113, _toDisplayString(_ctx.$t('head_of_pr_smm')), 1),
            _hoisted_114
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_116, [
      _createElementVNode("div", _hoisted_117, [
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("a", {
            class: "foot__col foot--logo",
            href: `https://gambeat.io/${_ctx.getReferrerParamsStr()}`
          }, _hoisted_121, 8, _hoisted_119),
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("a", _hoisted_123, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('about_us')), 1)
            ]),
            _createElementVNode("a", _hoisted_124, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('contacts')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_125, [
            _createElementVNode("a", _hoisted_126, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('advertisers')), 1)
            ]),
            _createElementVNode("a", _hoisted_127, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('publishers')), 1)
            ])
          ])
        ]),
        _hoisted_128
      ]),
      _hoisted_131
    ])
  ]))
}